export const theme = {
  colors: {
    primary: '#F78D2D', // Orange accent from Elite Wire branding
    secondary: '#37B6D4', // Teal/Blue accent from Elite Wire branding
    dark: '#333333', // Darker gray/near black background
    darker: '#2A2A2A', // Even darker background for sections
    darkest: '#222222', // Darkest background for footer/header
    light: '#FFFFFF', // White
    lightGray: '#E0E0E0', // Brightened from #CCCCCC for better visibility on dark backgrounds
    mediumGray: '#DDDDDD', // Medium gray for borders
    darkGray: '#AAAAAA', // Lightened from #444444 to a medium gray for better visibility on dark backgrounds
    black: '#000000',
    success: '#4CAF50',
    error: '#F44336',
    warning: '#FFC107',
  },
  fonts: {
    primary: "'Roboto', 'Helvetica Neue', sans-serif",
    heading: "'Montserrat', sans-serif",
  },
  fontSizes: {
    small: '0.875rem',
    medium: '1rem',
    large: '1.25rem',
    xlarge: '1.5rem',
    xxlarge: '2rem',
    xxxlarge: '3rem',
  },
  breakpoints: {
    xs: '320px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
    xxl: '1400px',
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '16px',
    round: '50%',
  },
  shadows: {
    small: '0 2px 4px rgba(0, 0, 0, 0.2)',
    medium: '0 4px 8px rgba(0, 0, 0, 0.2)',
    large: '0 8px 16px rgba(0, 0, 0, 0.2)',
  },
  transitions: {
    short: 'all 0.2s ease-in-out',
    medium: 'all 0.3s ease-in-out',
    long: 'all 0.5s ease-in-out',
  },
};

export type Theme = typeof theme;
export default theme; 